<template>
  <resource-collection>
    <template slot-scope="{item}">
      <product :product="item"/>
    </template>
  </resource-collection>
</template>

<script>
import Product from './Product.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';

export default {
  mixins: [collection],

  components: { Product, ResourceCollection },

  mounted() {
    Event.listen('productUpdated', product => this.update(product));
    Event.listen('productCreated', product => this.prepend(product));
    Event.listen('productDeleted', product => this.remove(product));
  },
};
</script>